import { Color } from '../../../enums/color'
import { ButtonColor } from '../types'

export const filledBg: Record<ButtonColor, string> = {
  primary: Color.Grey950,
  accent: Color.Lavender500,
  success: Color.Green700,
  warning: Color.Yellow400,
  danger: Color.Red700,
}

export const filledHoverBg: Record<ButtonColor, string> = {
  primary: Color.Black,
  accent: Color.Lavender600,
  success: Color.Green800,
  warning: Color.Yellow500,
  danger: Color.Red800,
}

export const filledActiveBg: Record<ButtonColor, string> = {
  primary: Color.Black,
  accent: Color.Lavender700,
  success: Color.Green900,
  warning: Color.Yellow600,
  danger: Color.Red900,
}

export const filledText: Record<ButtonColor, string> = {
  primary: Color.White,
  accent: Color.White,
  success: Color.White,
  warning: Color.Black,
  danger: Color.White,
}

export const tonalBg: Record<ButtonColor, string> = {
  primary: Color.Grey100,
  accent: Color.Lavender100,
  success: Color.Green100,
  warning: Color.Yellow100,
  danger: Color.Red100,
}

export const tonalHoverBg: Record<ButtonColor, string> = {
  primary: Color.Grey200,
  accent: Color.Lavender200,
  success: Color.Green200,
  warning: Color.Yellow200,
  danger: Color.Red200,
}

export const tonalActiveBg: Record<ButtonColor, string> = {
  primary: Color.Grey300,
  accent: Color.Lavender300,
  success: Color.Green300,
  warning: Color.Yellow300,
  danger: Color.Red300,
}

export const tonalText: Record<ButtonColor, string> = {
  primary: Color.Black,
  accent: Color.Black,
  success: Color.Black,
  warning: Color.Black,
  danger: Color.Red800,
}

export const subtleText: Record<ButtonColor, string> = {
  primary: Color.Grey950,
  accent: Color.Lavender600,
  success: Color.Green700,
  warning: Color.Yellow700,
  danger: Color.Red700,
}

export const subtleActiveText: Record<ButtonColor, string> = {
  primary: Color.Black,
  accent: Color.Lavender600,
  success: Color.Green700,
  warning: Color.Yellow700,
  danger: Color.Red700,
}

export const onColorBg: Record<ButtonColor, string> = {
  primary: Color.Grey200,
  accent: Color.Lavender200,
  success: Color.Green200,
  warning: Color.Yellow200,
  danger: Color.Red200,
}

export const onColorHoverBg: Record<ButtonColor, string> = {
  primary: Color.Grey300,
  accent: Color.Lavender300,
  success: Color.Green300,
  warning: Color.Yellow300,
  danger: Color.Red300,
}

export const onColorActiveBg: Record<ButtonColor, string> = {
  primary: Color.Grey400,
  accent: Color.Lavender400,
  success: Color.Green400,
  warning: Color.Yellow400,
  danger: Color.Red400,
}

export const onColorText: Record<ButtonColor, string> = {
  primary: Color.Black,
  accent: Color.Black,
  success: Color.Black,
  warning: Color.Black,
  danger: Color.Red800,
}
